// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"be8df778","227":"d39d6d49","453":"fd166e47","648":"85794a68","749":"7d2cee81"}[chunkId] + ".chunk.js";
};